<template>
  <md-card
    class="md-card-tabs"
    :class="[
      {'flex-column': flexColumn},
      {'nav-pills-icons': navPillsIcons},
      {'md-card-plain': plain}
    ]"
  >
    <md-card-header class="md-card-header-icon">
      <slot name="header">
        <div class="card-icon">
          <md-icon>shopping_cart</md-icon>
        </div>
        <h4 class="title">Cart</h4>
      </slot>
    </md-card-header>
    <md-card-content>
      <md-list class="nav-tabs line">
        <md-list-item
          v-for="(item, index) in tabName"
          @click="switchPanel(tabName[index])"
          :key="item"
          :class="[
            {active: isActivePanel(tabName[index])},
            {[getColorButton(colorButton)]: isActivePanel(tabName[index])}]"
        >
          {{ getTabDisplayName(tabName[index])}}
          <md-icon v-if="navPillsIcons">{{tabIcon[index]}}</md-icon>
        </md-list-item>
      </md-list>

      <transition name="fade" mode="out-in">
        <div class="tab-content">
          <div :class="getTabContent(index + 1)" v-for="(item, index) in tabName" :key="item"  v-if="isActivePanel(tabName[index])">
          
              <slot :name="getTabContent(index + 1)">This is the default text!</slot>
          
          </div>
        </div>
      </transition>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    flexColumn: Boolean,
    navPillsIcons: Boolean,
    plain: Boolean,
    tabName: Array,
    tabIcon: Array,
    colorButton: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activePanel: this.getActivePanel()
    };
  },
  methods: {
    getActivePanel() {
      if (this.$store.getters.selectedMedia.length == 0) {
        return this.tabName[0];
      }

      if (
        this.$store.getters.selectedProducts.length == 0 &&
        this.$store.getters.selectedMedia.length > 0
      ) {
        return this.tabName[1];
      }

      return this.tabName[0];
    },
    getTabDisplayName(type) {
      if (type === "Products") {
        return "Products (" + this.$store.getters.selectedProducts.length + ")";
      }

      if (type === "Media") {
        return "Media (" + this.$store.getters.selectedMedia.length + ")";
      }

      return type;
    },
    switchPanel(panel) {
      this.activePanel = panel;
    },
    isActivePanel(panel) {
      return this.activePanel == panel;
    },
    getColorButton: function(colorButton) {
      return "md-" + colorButton + "";
    },
    getTabContent: function(index) {
      return "tab-pane-" + index + "";
    }
  }
};
</script>

<style lang="css">
.max-width {
  width: 100%;
}
.min-midth {
  width: 0;
}


</style>
